import { Box, Button, useMediaQuery, useTheme } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import AddIcon from "@icons/myicons/plus.svg?react";
import ArrowRiseIcon from "@icons/myicons/arrow-rise.svg?react";
import LockIcon from "@icons/myicons/lock.svg?react";
import { AddPortfolio } from "@features/add/AddPortfolio";
import { PortfolioLimitGate } from "@features/add/PortfolioLimitGate";
import { NewTransactionMenu } from "./NewTransactionMenu";

export const InvestmentsActionButton = () => {
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.down("sm"));
  const isMd = useMediaQuery(theme.breakpoints.down("md"));
  const { t } = useTranslation();
  const [transactionMenuEl, setTransactionMenuEl] =
    useState<HTMLElement | null>(null);
  const [portfolioMenuEl, setPortfolioMenuEl] = useState<HTMLElement | null>(
    null
  );
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const handleOpenTransactionMenuClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => setTransactionMenuEl(event.currentTarget);

  const handleOpenPortfolioMenuClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    setPortfolioMenuEl(event.currentTarget);
  };

  return (
    <>
      <Box
        display="flex"
        alignItems="flex-start"
        flexDirection={isSm ? "column" : "row"}
        gap={isSm ? 3 : 2}
        width={isSm ? "100%" : "auto"}
        my={isMd ? 2.5 : 0}
      >
        <PortfolioLimitGate
          renderLocked={
            <Button
              variant="outlined"
              size="small"
              startIcon={<LockIcon width="16px" height="16px" />}
              sx={{ cursor: "not-allowed", width: isSm ? "100%" : "auto" }}
            >
              {t("investmentsPage.header.actions.newDepot")}
            </Button>
          }
        >
          <Button
            data-testid="new-portfolio-button"
            variant="outlined"
            size="small"
            aria-haspopup="menu"
            aria-expanded={Boolean(portfolioMenuEl)}
            aria-controls={portfolioMenuEl ? "new-portfolio-menu" : undefined}
            startIcon={<ArrowRiseIcon width="18px" height="12px" />}
            onClick={handleOpenPortfolioMenuClick}
            sx={{ width: isSm ? "100%" : "auto" }}
          >
            {t("investmentsPage.header.actions.newDepot")}
          </Button>
        </PortfolioLimitGate>
        <Button
          data-testid="new-transaction-button"
          variant="outlined"
          size="small"
          aria-haspopup="menu"
          aria-expanded={Boolean(transactionMenuEl)}
          aria-controls={transactionMenuEl ? "new-transaction-menu" : undefined}
          startIcon={<AddIcon width="18px" height="12px" />}
          onClick={handleOpenTransactionMenuClick}
          sx={{ width: isSm ? "100%" : "auto" }}
        >
          {t("investmentsPage.header.actions.main")}
        </Button>
      </Box>
      <NewTransactionMenu
        menuEl={transactionMenuEl}
        setMenuEl={setTransactionMenuEl}
      />
      <AddPortfolio
        menuEl={portfolioMenuEl}
        setMenuEl={setPortfolioMenuEl}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
      />
    </>
  );
};
